import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/search.png'


const _hoisted_1 = { class: "w-full px-4 md:px-8 lg:px-12 mt-4" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row items-center justify-evenly gap-6" }
const _hoisted_4 = { class: "w-full lg:w-1/2 space-y-6" }
const _hoisted_5 = { class: "relative search-container" }

import SuggestionDropdown from "@/components/SuggestionDropdown.vue";
import type { Query } from "@/models/Query";
import { mapQueryType } from "@/models/Query";
import { computed, ref, watch } from "vue";

interface Props {
  queries?: Query[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroSection',
  props: {
    queries: { default: () => [] }
  },
  emits: ["search", "select-query"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const searchTerm = ref("");
const showDropdown = ref(false);
const emit = __emit;

// Filter queries based on search term
const filteredQueries = computed(() => {
  if (!searchTerm.value || !props.queries) return [];
  
  const term = searchTerm.value.toLowerCase();
  return props.queries.filter(query => {
    return (
      query.id.toLowerCase().includes(term) ||
      query.neuronId.toLowerCase().includes(term) ||
      query.neuronText.toLowerCase().includes(term) ||
      query.author.toLowerCase().includes(term) ||
      query.componentType.toLowerCase().includes(term)
    );
  }).slice(0, 6); // Limit to 6 results
});

// Auto-search when typing
watch(searchTerm, (newVal) => {
  emit("search", newVal);
  showDropdown.value = newVal.length > 0;
});

// Define performSearch function
const performSearch = () => {
  console.log('Performing search for:', searchTerm.value);
  emit("search", searchTerm.value);
  showDropdown.value = false; // Close dropdown after search
};

// Handle query selection
const selectQuery = (query: Query) => {
  emit("select-query", query);
  searchTerm.value = query.id;
  showDropdown.value = false;
};

// Close dropdown when clicking outside - handled by SuggestionDropdown component

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-center lg:text-left" }, [
            _createElementVNode("h2", { class: "text-xl font-bold text-gray-900 leading-tight" }, " Ready to discover? "),
            _createElementVNode("h1", { class: "text-3xl md:text-4xl font-semibold mt-3 bg-gradient-to-r from-[#34dc1c] from-25% to-gray-900 bg-clip-text text-transparent" }, " Find your query's documentation ")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
              type: "text",
              placeholder: "Search by Query ID, Text or Type,...",
              class: "w-full h-16 px-6 rounded-full border-2 border-[#157813] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#34dc1c] text-lg"
            }, null, 512), [
              [_vModelText, searchTerm.value]
            ]),
            _createElementVNode("button", {
              onClick: performSearch,
              class: "absolute right-4 top-1/2 -translate-y-1/2 p-2 bg-[#157813] text-white rounded-full hover:bg-[#0e5a0c] transition-colors"
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "h-6 w-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                })
              ], -1)
            ]))]),
            _createVNode(SuggestionDropdown, {
              suggestions: filteredQueries.value.map(query => ({
                id: query.id,
                type: _unref(mapQueryType)(query.componentType),
                text: query.neuronText,
                author: query.author,
                runCount: query.extraction || 0,
                date: query.queryStartTime,
                tags: query.tags || [],
                features: query.features || []
              })),
              "is-visible": showDropdown.value,
              "is-loading": false,
              "highlighted-index": -1,
              "show-footer": true,
              "search-text": searchTerm.value,
              onSelect: _cache[1] || (_cache[1] = (suggestion) => selectQuery(props.queries?.find(q => q.id === suggestion.id)!)),
              onHighlight: () => {},
              onClose: _cache[2] || (_cache[2] = () => showDropdown.value = false),
              onSearch: _cache[3] || (_cache[3] = () => performSearch()),
              onSearchClick: _cache[4] || (_cache[4] = () => performSearch())
            }, null, 8, ["suggestions", "is-visible", "search-text"])
          ])
        ]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { class: "w-full lg:w-1/2 flex justify-center" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "Search interface",
            class: "w-full max-w-sm object-contain"
          })
        ], -1))
      ])
    ])
  ]))
}
}

})